import React from "react";
import styled from "styled-components";

const PersonalInfoSection = ({ formData, handleChange }) => {
    return (
        <>
            <div className="form-row">
                <div className="form-column">
                    <label htmlFor="firstname">First name*</label>
                    <input 
                        type="text" 
                        id="firstname" 
                        name="firstname" 
                        required 
                        value={formData.firstname} 
                        onChange={handleChange}
                    />
                </div>
                <div className="form-column">
                    <label htmlFor="surname">Last name*</label>
                    <input 
                        type="text" 
                        id="surname" 
                        name="surname" 
                        required 
                        value={formData.surname} 
                        onChange={handleChange}
                    />
                </div>
            </div>

            <label htmlFor="location">Location*</label>
            <input 
                type="text" 
                id="location" 
                name="location" 
                required 
                value={formData.location} 
                onChange={handleChange}
            />

            <div className="form-row">
                <div className="form-column">
                    <label htmlFor="email">Email*</label>
                    <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        required 
                        value={formData.email} 
                        onChange={handleChange} 
                        pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    />
                </div>
                <div className="form-column">
                    <label htmlFor="confirmEmail">Confirm Email*</label>
                    <input 
                        type="email" 
                        id="confirmEmail" 
                        name="confirmEmail" 
                        required
                        onChange={handleChange}
                        pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    />
                </div>
            </div>

            <div className="form-row">
                <div className="form-column">
                    <label htmlFor="contact">Contact*</label>
                    <input 
                        type="text" 
                        id="contact" 
                        name="contact" 
                        required 
                        value={formData.contact} 
                        onChange={handleChange}
                    />
                </div>

                <div className="form-column">
                    <label htmlFor="affiliation">Affiliation*</label>
                    <input 
                        type="text" 
                        id="affiliation" 
                        name="affiliation" 
                        required 
                        value={formData.affiliation} 
                        onChange={handleChange}
                    />
                </div>
            </div>
        </>
    );
};

export default PersonalInfoSection;